import React, { useEffect, useState } from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import CustomTabPanel from '../../shared/CustomTabPanel';
import { IExpression, IDeliveryType, ICustomAttributes } from '../../../models/configuration/plugin/IConfiguration';
import ExpressionsControl from '../../shared/config/ExpressionsControl';
import CustomAttributes from '../../shared/config/CustomAttributes';
import DtTabs from "../../ui/tab/DtTabs";

interface deliveryTypesTabProps {
    tabIndex: number,
    selectedDeliveryType: IDeliveryType | null;
    updateParent: (updatedDeliveryType: IDeliveryType) => void;
    children?: React.ReactNode
}

const DeliveryTypesTab: React.FC<deliveryTypesTabProps> = ({ selectedDeliveryType, updateParent }) => {

    const [selectedDeliveryTypeState, setSelectedDeliveryTypeState] = useState<IDeliveryType | null>(selectedDeliveryType);
    const [tabValue, setTabValue] = React.useState(0);

    const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
        setTabValue(newValue);
    };

    // Selected Package Changed
    useEffect(() => {
        if (selectedDeliveryType && selectedDeliveryType?.Id !== selectedDeliveryTypeState?.Id) {
            setSelectedDeliveryTypeState(selectedDeliveryType);
        }
    }, [selectedDeliveryType]);

    /* Expressions */
    const updateExpressions = (updatedExpressions: IExpression[]) => {
        if (selectedDeliveryTypeState && selectedDeliveryTypeState.Expressions) {
            const newDeliveryType = { ...selectedDeliveryTypeState, Expressions: updatedExpressions };
            setSelectedDeliveryTypeState(newDeliveryType);
            updateParent(newDeliveryType);
        }
    }

    const updateCustomAttributes = (updatedCustomAttributes: ICustomAttributes) => {
        if (selectedDeliveryTypeState) {
            const baseState = selectedDeliveryType || selectedDeliveryTypeState;
            const newDeliveryType = { ...baseState, CustomAttributes: updatedCustomAttributes };
            setSelectedDeliveryTypeState(newDeliveryType);
            updateParent(newDeliveryType);
        }
    }

    function a11yProps(index: number) {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        };
    }

    const tabConfig = [
        { label: "Expressions" },
        { label: "Attributes" }
    ];

    return (
        <Box>
            <DtTabs
                tabs={tabConfig}
                value={tabValue}
                onChange={handleTabChange}
            >
                { [
                    <ExpressionsControl
                        key="expressions"
                        expressions={selectedDeliveryTypeState?.Expressions}
                        updateParentExpressions={updateExpressions}
                        title="Any 'False' Expression will suppress/hide control"
                        previewLength={15}
                    />,
                    <CustomAttributes
                        key="attributes"
                        customAttributes={selectedDeliveryTypeState?.CustomAttributes}
                        updateParent={updateCustomAttributes}
                        selectedDeliveryType={selectedDeliveryTypeState}
                    />
                ]}
            </DtTabs>
        </Box>
    )
}

export default DeliveryTypesTab;